<template>
  <div v-if="data.length">
    <h5 class="page-title mb-4">
      Continue assistindo
    </h5>
    <home-carousel
      :list="data"
      :per-page-custom="[
        [576, 2],
        [768, 3],
        [992, 4.3],
        [1200, 6],
        [1500, 6]
      ]"
    >
      <template #default="{ data }">
        <last-lesson-card :lesson="data" />
      </template>
    </home-carousel>
  </div>
</template>
<script>
import LastLessonCard from "@/components/home/LastLessonCard";
import HomeCarousel from "@/components/home/HomeCarousel";
export default {
  props: {
    data: {
      type: Array,
      default: () => {}
    }
  },
  components: { HomeCarousel, LastLessonCard }
};
</script>
